import { useMemo } from "react";
import { useGetCueQuery, useGetCuesQuery } from "./cueEndpoints";
import { Cue } from "../../entities/cue";

export function useCue(cueID: number | undefined) {
  const cueQuery = useGetCueQuery(cueID ?? 0, {
    skip: (cueID ?? 0) <= 0,
  });
  const cueEntity = cueQuery.data;

  return useMemo(() => {
    const ret: typeof cueQuery & { cue?: Cue | undefined } = {
      ...cueQuery,
    };
    if (cueEntity) ret.cue = new Cue(cueEntity);
    return ret;
  }, [cueEntity]);
}

export function useCues(params?: any, options?: any) {
  const cueQuery = useGetCuesQuery(params, options);
  const cueEntitiesMap = cueQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof cueQuery & {
      cues?: Cue[];
      cuesMap?: { [id: number]: Cue };
    } = {
      ...cueQuery,
      cues: [],
      cuesMap: {},
    };
    if (cueEntitiesMap) {
      const cues: Cue[] = [];
      const cuesMap: { [id: number]: Cue } = {};

      for (const key in cueEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(cueEntitiesMap, key)) {
          const c = cueEntitiesMap[key];
          const cue = new Cue(c);
          cues.push(cue);
          cuesMap[cue.id] = cue;
        }
      }
      cues.sort((a, b) => a.order - b.order);
      ret.cues = cues;
      ret.cuesMap = cuesMap;
    }

    return ret;
  }, [cueEntitiesMap]);
}
